import { useDispatch, useSelector } from 'react-redux';
import { useAbsoluteNavigate } from '@/hooks/useAbsoluteNavigate';
import {
  selectOntarioLocationCheckError,
  selectOntarioLocationCheckStatus,
} from '@/store/selectors/commonSelectors';
import { selectUiIsSingleGame } from '@/store/ui/selectors';
import { setOntarioLocationCheckStatus } from '@/store/actions/commonActions';
import { OntarioLocationCheckStatus } from '@/models/enum/ontario-location-check-status.enum';
import React from 'react';
import BrowserPermission from '@/features/modal/modals/geo-location/BrowserPermission';
import LocationError from '@/features/modal/modals/geo-location/LocationError';
import LocationCheckProgress from '@/features/modal/modals/geo-location/LocationCheckProgress';

export const GeoLocationModal = ({ closeModal }: { closeModal: () => void }) => {
  const dispatch = useDispatch();
  const navigate = useAbsoluteNavigate();
  const ontarioGeoLocationStatus = useSelector(selectOntarioLocationCheckStatus);
  const ontarioGeoLocationError = useSelector(selectOntarioLocationCheckError);
  const isGameUrl = useSelector(selectUiIsSingleGame);

  const closeModalOnClick = () => {
    if (isGameUrl) {
      navigate('/');
    }
    closeModal();
  };

  const modalOnClick = () => {
    dispatch(setOntarioLocationCheckStatus(OntarioLocationCheckStatus.Retry));
    !isGameUrl && closeModal();
  };

  const inProgressOnClick = () => {
    closeModal();
    navigate('/');
  };

  if (ontarioGeoLocationStatus === OntarioLocationCheckStatus.BrowserPermission) {
    return <BrowserPermission closeModalOnClick={closeModalOnClick} />;
  }

  if (ontarioGeoLocationStatus === OntarioLocationCheckStatus.Error) {
    return (
      <LocationError
        closeModalOnClick={closeModalOnClick}
        onClick={modalOnClick}
        error={ontarioGeoLocationError}
      />
    );
  }

  if (ontarioGeoLocationStatus === OntarioLocationCheckStatus.InProgress && isGameUrl) {
    return (
      <LocationCheckProgress closeModalOnClick={inProgressOnClick} onClick={inProgressOnClick} />
    );
  }

  return null;
};
